<template>
    <div class="NoData">
        <img :src="require('$img/noData.png')" height="157" width="100%"/>
        <div class="txt">
            <div class="title" v-html="title"></div>
            <div class="title-mg" v-html="message"></div>
        </div>
        <el-button v-if="btTitle" @click="edit" class="btn">{{btTitle}}</el-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        props:['title','message','router','btTitle'],
        methods: {
            edit() {
                this.$router.push(this.router);
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '$styles/global.scss';

.NoData{
    width: 100%;
    height: 100%;
    background-color: #FFF;
    padding: 120px 0 170px 0;
    @include flex-box();
    font-size: 14px;
    color: $main-color;

    img{
        width: 198px;
    }

    .txt{
        margin: 30px 0;
        width: 100%;
        text-align: center;
    }

    .title{
        width: 100%;
    }

    .title-mg{
        width: 100%;
        margin-top: 10px;
    }

    .btn{
        padding: 6px 37px;
        height: 40px;
        text-align: center;
        color: #fff;
        margin-top:10px;
        font-size: 14px;
        background: #4061F8;
        border-radius:8px;
        cursor: pointer;
    }
}
</style>
